import update from '../../utilities/update';
export const error=(state,action)=>{
    return update(state,{
        loading:false,
        error:action.payload,
    })
}

